import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import { RootState } from 'app/store';
import { QueryParams } from 'shared/types';
import { WasteCenterType } from 'features/service-providers/models';
import { fetchWasteCenterTypes, selectWasteCenterTypes, selectWasteCenterTypesLoading } from '../store';

export const useWasteCenterTypesQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const useWasteCenterTypes = (query: QueryParams) => {
  return useFetchByParams<WasteCenterType[]>({
    action: fetchWasteCenterTypes,
    dataSelector: selectWasteCenterTypes,
    loadingSelector: (state: RootState) => selectWasteCenterTypesLoading(state),
    params: query,
  });
};
